import { getRootStore } from "./root-store"

const CONFIG = require("../config/env")
const CONFIG_DEV = require("../config/env.dev")

export default () => {
  const { tokenStore = {} as any } = getRootStore()
  return !tokenStore.demo ? CONFIG : {
    ...CONFIG_DEV,
    MIXPANEL_TOKEN: CONFIG.MIXPANEL_TOKEN,
    APPCENTER_DEPLOYMENT_KEY_ANDROID: CONFIG.APPCENTER_DEPLOYMENT_KEY_ANDROID,
    APPCENTER_DEPLOYMENT_KEY_IOS: CONFIG.APPCENTER_DEPLOYMENT_KEY_IOS
  };
}
